"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Indicator = void 0;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
exports.Indicator = {
  name: 'Indicator',
  autoRoutes: ['create', 'update', 'list'],
  includeInMetrics: true,
  useSlices: true,
  groupName: 'Data',
  table: {
    fieldNames: ["name", "unit", "layout"],
    fields: {
      info: {
        title: 'name',
        weight: 1
      },
      unit: {
        weight: 1.5
      },
      layout: {
        title: 'Layout',
        weight: 1.5
      }
    }
  },
  filters: {
    fields: {
      types: {
        entityTypeName: 'IndicatorType'
      },
      unit: {
        entityTypeName: 'Unit'
      },
      dataSets: {
        entityTypeName: 'DataSet'
      }
    }
  },
  list: {
    resultsVariant: 'table',
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      title\n      unit { id name slug }\n      description { id text }\n      precision\n      dataSets { id name slug openGraph { id url image { id url } } }\n    "], ["\n      title\n      unit { id name slug }\n      description { id text }\n      precision\n      dataSets { id name slug openGraph { id url image { id url } } }\n    "])))
  },
  form: {
    modal: {
      fill: true,
      maxWidth: "800px"
    },
    fieldSets: [{
      name: "overview"
    }, {
      name: "taxonomies"
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      title: {
        type: 'text',
        description: "Specify a title which will take precedence over the name when labelling this {{INDICATOR}}"
      },
      subtitle: {
        type: 'text',
        description: "Specify a subtitle as a sub-label for this {{INDICATOR}}"
      },
      unit: {
        type: 'linked',
        entityTypeName: "Unit"
      },
      layout: {
        type: 'linked',
        label: "Layout",
        entityTypeName: 'IndicatorLayout',
        fieldSet: 'overview',
        description: "Select the {{INDICATOR_LAYOUT}} used to present this {{INDICATOR}}. If this is empty, a default layout will be used"
      },
      description: {
        type: 'longText'
      },
      types: {
        type: 'linkedMultiple',
        entityTypeName: 'IndicatorType',
        fieldSet: 'overview'
      },
      supportingIndicators: {
        type: 'linkedMultiple',
        label: 'Supporting Indicators',
        recommended: false,
        entityTypeName: 'Indicator',
        description: "Select one or more {{INDICATORS}} which support the value in this {{INDICATOR}}. For example, a percentage value might be supported by another {{INDICATOR}} with a specific value used to calcualte that result."
      },
      icon: {
        type: 'linked',
        entityTypeName: 'Icon',
        fieldSet: 'overview'
      },
      color: {
        type: 'linked',
        entityTypeName: 'Color',
        fieldSet: 'overview'
      },
      precision: {
        type: 'int',
        recommended: false,
        description: "For numeric indicators, what decimal precision should values be displayed at? Note: this doesn't affect the recorded precision, just how it is displayed."
      },
      dataSetId: {
        type: 'text',
        recommended: false,
        description: "Specify an ID to uniquely identify this {{INDICATOR}}. This might be useful to tie this Indicator to values coming from an external API, for example",
        monospace: true
      },
      outlineNumber: {
        type: 'text',
        recommended: false
      },
      dataSets: {
        type: 'linkedMultiple',
        recommended: false,
        entityTypeName: 'DataSet'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        description: "Are there any specific {{LINKS}} related to this {{INDICATOR}}? This might consist of website references which are sources for the {{INDICATOR_RESULTS}} entered against this {{INDICATOR}}."
      },
      variables: {
        type: 'linkedMultiple',
        recommended: false,
        entityTypeName: 'Variable'
      },
      targets: {
        type: 'linkedMultiple',
        recommended: false,
        entityTypeName: 'Target'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      }
    })
  }
};
var templateObject_1;